function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0asdsad123",
  d: "M382.7,226.8L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9s-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62.1 L293.4,246L109.3,430c-5.1,5.1-7.9,11.8-7.9,19s2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265 c5.1-5.1,7.9-11.9,7.8-19.1C390.5,238.7,387.8,231.9,382.7,226.8z"
})));
const SvgArrowButton = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#92BA43",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492 492",
    style: {
      enableBackground: "new 0 0 492 492"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-button.cd005628.svg";
export { ForwardRef as ReactComponent };